<div class="avatar-container" (click)="onChangeImage()">
  @if (displayImageUrl()) {
    <glxy-avatar [src]="displayImageUrl()" [width]="220" />
  } @else {
    <glxy-avatar [svgIcon]="fallbackSvg()" [width]="220" />
  }

  <div class="edit-overlay">
    <mat-icon>photo_camera</mat-icon>
  </div>
</div>
